module.exports = __webpack_public_path__ + "static/media/logout.365ee7f2.svg";